module.exports = __webpack_public_path__ + "static/img/brees-2019-top-image-thumb.a6f1e88.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2019-top-image-thumb.gif
// module id = lUvo
// module chunks = 1